import React, { useState, useEffect } from "react";
import FormattedDay from "./FormattedDay";
import "./WeatherForecast.css";
import axios from "axios";

export default function WeatherForecast(props) {
  const [loaded, setLoaded] = useState(false);
  const [forecast, setForecast] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.info.coord]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    console.log(response);
    setLoaded(true);
  }

  if (!loaded) {
    const apiKey = "49b631c45785fe73d2a88477803dea22";
    let lon = props.info.coord.lon;
    let lat = props.info.coord.lat;
    let url = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;
    axios.get(url).then(handleResponse);

    return null;
  } else {
    return (
      <div className="WeatherForecast">
        <div className="row">
          {forecast.map(function (dailyForecast, index) {
            if (index < 6) {
              return (
                <div className="col" key={index}>
                  <div className="forecastDay">
                    <FormattedDay date={new Date(forecast[index].dt * 1000)} />
                  </div>{" "}
                  <img
                    height={70}
                    src={`http://openweathermap.org/img/wn/${dailyForecast.weather[0].icon}@2x.png`}
                    alt={props.info.description}
                  />
                  <div className="forecastTemperature">
                    <span className="forecastTemperartureMax">
                      {Math.round(dailyForecast.temp.max)}°{" "}
                    </span>
                    <span className="forecastTemperartureMin">
                      {Math.round(dailyForecast.temp.min)}°{" "}
                    </span>
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  }
}
